<template>
  <b-row class="px-sm-4 px-md-4 px-lg-0 pt-sm-3">
    <b-col cols="12">
      <PageTitle title="Lista de banners" />
    </b-col>
    <b-col class="mt-5 mb-2 d-flex align-items-center justify-content-between">
      <h3 class="title font-weight-bold">Banner criados</h3>
      <b-button
        pill
        variant="success"
        @click="
          $router.push({
            name: 'profissional-website-banner-novo',
          })
        "
      >
        <i class="fas fa-plus-circle mr-2"></i>
        Criar banner
      </b-button>
    </b-col>
    <b-col cols="12">
      <b-table
        striped
        hover
        :fields="table.headers"
        :items="table.records"
        :busy="loading"
      >
        <template #table-busy>
          <div class="text-center my-2">
            <b-spinner class="align-middle mr-2"></b-spinner>
            <strong>Carregando...</strong>
          </div>
        </template>
        <template #cell(image)="data">
          <b-img
            :src="`${getImagesAddress}${data.item.image}`"
            width="100%"
          ></b-img>
        </template>
        <template #cell(url)="data">
          <span>{{
            data.item.url && data.item.url.length > 40
              ? data.item.url.slice(0, 40) + '...'
              : data.item.url
          }}</span>
        </template>
        <template #cell(actions)="data">
          <b-button
            class="mr-2"
            variant="primary"
            size="sm"
            title="Editar banner"
            @click="
              $router.push({
                name: 'profissional-website-banner-editar',
                params: { id: data.item.bannerId },
              })
            "
          >
            <i class="fas fa-edit"></i>
          </b-button>
          <b-button
            variant="danger"
            size="sm"
            title="Excluir banner"
            @click="deleteBannerById(data.item.bannerId)"
          >
            <i class="fas fa-trash"></i>
          </b-button>
        </template>
      </b-table>
    </b-col>
  </b-row>
</template>

<script>
import PageTitle from 'Components/PageTitle.vue';
import makeToast from '@/mixins/makeToast';

import { mapActions, mapGetters, mapState } from 'vuex';

export default {
  name: 'CustomizationListBanner',
  mixins: [makeToast],
  components: {
    PageTitle,
  },
  data() {
    return {
      loading: false,
      table: {
        headers: [
          {
            key: 'index',
            thClass: 'd-none',
            tdClass: 'd-none',
          },
          {
            key: 'bannerId',
            thClass: 'd-none',
            tdClass: 'd-none',
          },
          {
            key: 'image',
            label: 'Imagem',
            sortable: false,
          },
          {
            key: 'urlToRedirect',
            label: 'Url',
            sortable: false,
          },
          {
            key: 'createdAt',
            label: 'Criado em',
            sortable: true,
            headerClass: "d-none d-md-table-cell", 
            tdClass: "d-none d-md-table-cell" ,
            thClass: "d-none d-md-table-cell" 
          },
          {
            key: 'actions',
            label: 'Ações',
            sortable: false,
          },
        ],
        records: [],
      },
    };
  },
  computed: {
    ...mapState(['dadosUsuario']),
    ...mapGetters('general', ['getImagesAddress']),
  },
  mounted() {
    this.list();
  },
  methods: {
    ...mapActions('professional', [
      'listBanner',
      'deleteBanner',
    ]),
    list() {
      this.loading = true;

      this.listBanner(this.dadosUsuario.informacoes.id)
        .then((response) => {
          this.table.records = response.data.data || [];
        })
        .catch(() => {
          this.makeToast(
            'Erro',
            'Houve um erro ao trazer os banners',
            'danger'
          );
        })
        .finally(() => {
          this.loading = false;
        });
    },
    deleteBannerById(bannerId) {
      if (!bannerId) return;

      this.$store.dispatch('startLoader');

      this.deleteBanner(bannerId)
        .then(() => {
          const banner = this.table.records.find(
            (x) => x.bannerId === bannerId
          );
          const index = this.table.records.indexOf(banner);

          this.table.records.splice(index, 1);
        })
        .catch(() => {
          this.makeToast('Erro', 'Houve um erro ao excluir o banner', 'danger');
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        });
    },
  },
};
</script>
